// actionTypes.js
export const SET_VALUE_PROJET = "SET_VALUE_PROJET";
export const SET_CURRENT_PAGE_PROJET = "SET_CURRENT_PAGE_PROJET";
export const SET_ORDER_PROJET = "SET_ORDER_PROJET";
export const SET_SORT_FIELD_PROJET = "SET_SORT_FIELD_PROJET";
export const SET_PAGE_SIZE_PROJET = "SET_PAGE_SIZE_PROJET";
export const SET_CUSTOM_FILTERS_PROJET = "SET_CUSTOM_FILTERS_PROJET";
export const SET_SORTING_PROJET = "SET_SORTING_PROJET";
export const SET_ACTIVE_TAB_PROJET = "SET_ACTIVE_TAB_PROJET";
export const SET_QUERY_PROJET = "SET_QUERY_PROJET";
export const SET_ACTIF_PROJET = "SET_ACTIF_PROJET";
export const SET_SELECTED_OPTION_FILTERS_PROJET =
  "SET_SELECTED_OPTION_FILTERS_PROJET";
export const SET_SELECTED_OPTION_ID_PROJET = "SET_SELECTED_OPTION_ID_PROJET";
export const SET_COLUMN_PROJET = "SET_COLUMN_PROJET";
